import { agentStatusType, agentScoresType, folioScoresType } from '../../features/workflow/types';

export type wfDisplayType = {
  bgColor: string;
  name: string;
  abbr?: string;
};
type wfDisplayEnumType<TType extends number> = {
  [key in TType | number]?: wfDisplayType;
};

export const agentStatusDisplay: wfDisplayEnumType<agentStatusType> = {
  [agentStatusType.Ready]: {
    bgColor: '#d8f8db',
    name: 'Ready'
  },
  [agentStatusType.Away]: {
    bgColor: '#f8d8d8',
    name: 'Away'
  }
};

export const agentScoreDisplay: wfDisplayEnumType<agentScoresType> = {
  [agentScoresType.Booked]: {
    bgColor: '#0078d4',
    abbr: 'B',
    name: 'Booked'
  },
  [agentScoresType.Options]: {
    bgColor: '#007E6D',
    abbr: 'O',
    name: 'Options'
  },
  [agentScoresType.Changed]: {
    bgColor: '#D45D00',
    abbr: 'C',
    name: 'Changed'
  },
  [agentScoresType.Canceled]: {
    bgColor: '#FF0000',
    abbr: 'X',
    name: 'Canceled'
  },
  [agentScoresType.Actions]: {
    bgColor: '#006400',
    abbr: 'A',
    name: 'Actions'
  }
};

export const folioScoreDisplay: wfDisplayEnumType<folioScoresType> = {
  [folioScoresType.Merged]: {
    bgColor: '#0078d4',
    abbr: 'M',
    name: 'Merged'
  },
  [folioScoresType.Invoiced]: {
    bgColor: '#007E6D',
    abbr: 'I',
    name: 'Invoiced'
  },
  [folioScoresType.Requested]: {
    bgColor: '#D45D00',
    abbr: 'R',
    name: 'Requested'
  }
};

export { agentScoresType };
